import React, { useRef } from 'react';
import { Dialog, DialogContent, Grid, Button } from '@mui/material';
import Remarks from '../../../helpers/Remarks/Remarks';

const SeeMoreDialog = ({ open, onOpen, onClose, room }) => {
  const buttonRef = useRef(null);

  const handleClose = () => {
    onClose();
    buttonRef.current?.focus();
  };

  return (
    <Grid
      sx={{
        textAlign: 'center',
      }}
    >
      <Button
        ref={buttonRef}
        id="ver-mas-boton"
        sx={{
          textAlign: 'center',
          lineHeight: 1,
          fontSize: { xs: '14px', sm: '16px' },
        }}
        onClick={onOpen}
      >
        ver más información
      </Button>

      <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
        <DialogContent
          sx={{
            px: { xs: 2, sm: 4 },
            py: { xs: 2, sm: 3 },
          }}
        >
          <Remarks room={room} setSeeMore={handleClose} seeTitle />
        </DialogContent>
      </Dialog>
    </Grid>
  );
};

export default SeeMoreDialog;
